import React from 'react';
import PropTypes from 'prop-types';

const Stars = (props) => {
  const createStars = () => {
    let stars = [];
    for(let i=0; i<props.count; i++) {
      stars.push(<i key={i} className="fas fa-star" />);
    }
    return stars;
  }

  return (
    <React.Fragment>
      {createStars()}
    </React.Fragment>
  );
}

Stars.propTypes = {
  count: PropTypes.number.isRequired
}

export default Stars;